import React from 'react';
import { Form, Input, Tag, Tooltip, Icon } from 'antd';
import s from '../AnnualReviewReport.module.scss';

const getDisplayValue = value => {
  if (value == null) return '—';
  if (typeof value === 'number') return value.toLocaleString();
  return value;
};

const getTagColor = healthColor => {
  if (healthColor === 'green') return 'green';
  if (healthColor === 'red') return 'red';
  return null;
};

const StatRow = ({ label, value, id, healthColor, tooltip }) => {
  const displayValue = getDisplayValue(value);

  const labelContent = tooltip ? (
    <span>
      {label}{' '}
      <Tooltip title={tooltip}>
        <Icon
          type="info-circle"
          style={{ color: '#8c8c8c', cursor: 'help' }}
          aria-label={`More info about ${label}`}
        />
      </Tooltip>
    </span>
  ) : (
    label
  );
  const tagColor = getTagColor(healthColor);

  return (
    <Form.Item label={labelContent} colon={false} className={s.statRow}>
      <div className={s.statRowContent}>
        <Input
          id={id}
          value={displayValue}
          disabled
          aria-label={`${label}: ${displayValue}`}
        />
        {tagColor && (
          <Tag
            color={tagColor}
            className={s.statHealthTag}
            aria-label={`Health: ${healthColor}`}
          >
            {healthColor}
          </Tag>
        )}
      </div>
    </Form.Item>
  );
};

export default StatRow;
